// First-party page views (Nav, 2026-10-12): one tiny POST per page a person opens, carrying the
// page's TYPE only ("vote", "present", "create"...), never a poll code, with no cookie and no id.
// The server counts it in Analytics Engine and stops counting first when usage climbs. This is the
// only measurement the vote page sends; the product funnel (lib/analytics) still never loads there.
import { PAGE_TYPES, type PageType } from "@flp/core";

export function pageView(route: string): void {
  try {
    // Global Privacy Control and Do Not Track are honored: nothing is sent.
    const nav = navigator as Navigator & { globalPrivacyControl?: boolean };
    if (nav.globalPrivacyControl || nav.doNotTrack === "1") return;
    const p: PageType = route === "checkout-fake" ? "checkout" : (PAGE_TYPES as readonly string[]).includes(route) ? (route as PageType) : "notfound";
    const body = JSON.stringify({ p });
    if (navigator.sendBeacon?.("/api/pv", new Blob([body], { type: "application/json" }))) return;
    void fetch("/api/pv", { method: "POST", headers: { "content-type": "application/json" }, body, keepalive: true }).catch(() => {});
  } catch {
    // Measurement never breaks the product.
  }
}
